import { Grid, TextField, Box } from '@mui/material';

export function BankDetailsStep({ formik }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    formik.setFieldValue(`bankDetails.${name}`, value);
  };

  const getError = (field) => {
    return formik.touched.bankDetails?.[field] && Boolean(formik.errors.bankDetails?.[field]);
  };

  const getHelperText = (field) => {
    return formik.touched.bankDetails?.[field] && formik.errors.bankDetails?.[field];
  };

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Account Holder Name"
            name="accountHolder"
            value={formik.values.bankDetails?.accountHolder || ''}
            onChange={handleChange}
            error={getError('accountHolder')}
            helperText={getHelperText('accountHolder')}
          />
        </Grid>
        
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Bank Name"
            name="bankName"
            value={formik.values.bankDetails?.bankName || ''}
            onChange={handleChange}
            error={getError('bankName')}
            helperText={getHelperText('bankName')}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="Account Number"
            name="accountNumber"
            value={formik.values.bankDetails?.accountNumber || ''}
            onChange={handleChange}
            error={getError('accountNumber')}
            helperText={getHelperText('accountNumber')}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label="IFSC Code"
            name="ifsc"
            value={formik.values.bankDetails?.ifsc || ''}
            onChange={handleChange}
            error={getError('ifsc')}
            helperText={getHelperText('ifsc')}
            slotProps={{ htmlInput: { style: { textTransform: 'uppercase' } } }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
